import type { ProductKeys } from '../../constants/products';
import { type FireAnalyticsEvent } from '../../types';

export const onRecommendationsDegraded = ({
	searchSessionId,
	reason,
}: {
	searchSessionId?: string;
	reason: 'timeout' | 'failure';
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationStatus',
	attributes: {
		additionalAttributes: {
			status: 'DEGRADED',
			searchSessionId,
			reason,
		},
	},
});

export const onRecommendationsCacheAccess = ({
	searchSessionId,
	hit,
}: {
	searchSessionId?: string;
	hit: boolean;
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationStatus',
	attributes: {
		additionalAttributes: {
			status: hit ? 'CACHE_HIT' : 'CACHE_MISS',
			searchSessionId,
		},
	},
});

export const onInvalidIdentifiers = ({
	searchSessionId,
}: {
	searchSessionId?: string;
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationStatus',
	attributes: {
		additionalAttributes: {
			status: 'NO_IDENTIFIER',
			searchSessionId,
		},
	},
});

export const onRecommendationsServed = ({
	searchSessionId,
	visibleProductsToAuth,
	recommended3pApps,
}: {
	searchSessionId?: string;
	visibleProductsToAuth: (ProductKeys | undefined)[];
	recommended3pApps: string[];
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationServed',
	attributes: {
		additionalAttributes: {
			searchSessionId,
			visibleProductsToAuth,
			recommended3pApps,
		},
	},
});
